import vehicleCl from './cl';
import vehicleCo from './co';
import vehiclePe from './pe';
import formatter from 'helpers/formatter';

const vehicle: any = {
  cl: vehicleCl,
  pe: { ...vehicleCl, ...vehiclePe },
  co: { ...vehicleCl, ...vehicleCo }
};

const trays = vehicle[formatter.getCountry()].trays;
export { trays };

export default vehicle[formatter.getCountry()];
